<template>
    <div class="message-box dialog-mask terms-of-service-dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ $t('error.modal.20255.title') }}</h4>
                </div>
                <div class="modal-body">
                    <p>{{ $t('error.modal.20255.desc1') }}</p>
                    <br />
                    <p>
                        <a target="_blank" class="link" href="https://www.nexon.com/main/en/legal/tou/">
                            {{ $t('error.modal.20255.terms-of-service') }}
                        </a>
                    </p>
                    <br />
                    <p>{{ $t('error.modal.20255.desc2') }}</p>
                </div>
                <div class="modal-footer">
                    <ModalMultiButtons
                        :btn-primary-text="$t('error.modal.20255.button')"
                        :btn-secondary-text="$t('cancel')"
                        :primary-button-click="clickAccept"
                        :secondary-button-click="clickCancel"
                    ></ModalMultiButtons>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ModalMultiButtons } from '@arena/toolkit';
import modalEscMixin from '@/mixins/modalEscMixin';

export default {
    components: {
        ModalMultiButtons,
    },
    mixins: [modalEscMixin],
    data() {
        return {};
    },
    mounted() {
        dataLayer.push({
            event: 'SignupLoginErrorView',
            errorName: 'Account Reconsent',
        });
    },
    created() {
        this.handleEscCallbackToMixin = this.clickCancel;
    },
    methods: {
        async clickAccept() {
            dataLayer.push({
                event: 'SignupLoginErrorClick',
                errorName: 'Account Reconsent',
                errorClick: 'Accept Terms of Service',
            });

            this.$accountAPI
                .post('/no-auth/terms/consent', {
                    consentLocation: this.$store.state.isApplication ? 'LAUNCHER' : 'WEB',
                })
                .then(() => {
                    this.$store.dispatch('login/loginComplete');
                    this.$close();
                })
                .catch((error) => {
                    this.$close();
                    this.$error(error);
                });
        },
        async clickCancel() {
            dataLayer.push({
                event: 'Closed Terms of Service Modal',
            });
            this.$close();
        },
    },
};
</script>

<style lang="less" scoped>
.terms-of-service-dialog {
    .link {
        color: #0077ff;
        font-weight: bold;
        text-decoration: underline;
        text-underline-position: under;
        &:hover {
            color: #4ca1ff;
        }
    }
}
</style>
